import React, { useMemo } from 'react';
import { StatusText } from '../../styles';

const UsageLabelAndValue: React.FC<{
  label: string;
  value: string;
  unit: string;
}> = ({ label, value, unit }) => {
  const context = useMemo(
    () =>
      `${value === '無資料' ? '無資料' : `${value.toLocaleString()} ${unit}`}`,
    [value, unit]
  );
  return (
    <>
      <StatusText>{`${label}：`}</StatusText>
      <StatusText>{context}</StatusText>
    </>
  );
};

export default UsageLabelAndValue;
